/***************************************************************
8/2/2019
Alexander Self
solutions_table.js
- Displays a list of chemical solutions
***************************************************************/
import { convertToGalAndSum } from '../../cult_utils';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  chemicalList: PropTypes.array,
  formId: PropTypes.string,
  readOnly: PropTypes.bool,
  solutions: PropTypes.array,
  edit: PropTypes.func,
  _delete: PropTypes.func
};

const SolutionsTable = ({ solutions, chemicalList, formId, edit, _delete, readOnly }) => {
  if (!solutions) return <span></span>;
  if (readOnly) {
    return (
      <table className="bordered highlight responsive-table centered">
        <thead>
          <tr>
            <th>Chemical</th>
            <th>Quantity / Unit</th>
            <th>Chemical %</th>
            <th>REI</th>
            <th>Pre-Harvest</th>
          </tr>
        </thead>
        <tbody>
          {
            solutions.map((s, i) => {
              let chem = chemicalList.find((c) => c.id === Number(s.chemId));
              return (
                <tr key={s.id}>
                  <td>{ chem.name } - { chem.type }</td>
                  <td>{ s.chemDosage1 } { s.chemDosage2 }</td>
                  <td>{ isNaN(s.percentageUsed) ? 0 : s.percentageUsed }%</td>
                  <td>{ s.rei } days</td>
                  <td>{ s.preHarvest } days</td>
                </tr>
              )
            })
          }
        </tbody>
        <tfoot>
          <tr>
            <td><center>Total Gallons</center></td>
            <td><b><center>{ convertToGalAndSum(solutions) } gal</center></b></td>
          </tr>
        </tfoot>
      </table>
    )
  }
  return (
    <table className="bordered highlight responsive-table centered">
      <thead>
        <tr>
          <th>Chemical</th>
          <th>Quantity / Unit</th>
          <th>Chemical %</th>
          <th>REI</th>
          <th>Pre-Harvest</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        {
          solutions.map((s, i) => {
            let chem = chemicalList.find((c) => c.id === Number(s.chemId));
            return (
              <tr key={s.id}>
                <td>{ chem.name } - { chem.type }</td>
                <td>{ s.chemDosage1 } { s.chemDosage2 }</td>
                <td>{ isNaN(s.percentageUsed) ? 0 : s.percentageUsed }%</td>
                <td>{ s.rei } days</td>
                <td>{ s.preHarvest } days</td>
                <td>
                  <button onClick={() => edit(s, formId)} className="btn-floating waves-effect waves-light blue table-btn">
                    <i className="material-icons">mode_edit</i>
                  </button>
                </td>
                <td>
                  <button onClick={() => _delete(s)} className="btn-floating waves-effect waves-light red table-btn">
                    <i className="material-icons">clear</i>
                  </button>
                </td>
              </tr>
            )
          })
        }
      </tbody>
      <tfoot>
        <tr>
          <td><center>Total Gallons</center></td>
          <td><b><center>{ convertToGalAndSum(solutions) } gal</center></b></td>
        </tr>
      </tfoot>
    </table>
  )
};

SolutionsTable.propTypes = propTypes;
export default SolutionsTable;



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_solution_table.js